import { Instance, types, flow } from "mobx-state-tree";
import axios from "axios";
import { ONEMAP_API } from "@constants/api";
import { AlertResultApi } from "@utils/alert";

export const initialStatePostalCode = {
  postalCodesResult: [],
  fetching: "done",
};

const PostalCode = types.model({
  ADDRESS: types.string,
  BLK_NO: types.string,
  BUILDING: types.string,
  LATITUDE: types.string,
  LONGITUDE: types.string,
  POSTAL: types.string,
  ROAD_NAME: types.string,
  SEARCHVAL: types.string,
  X: types.string,
  Y: types.string,
});

export const PostalCodes = types
  .model({
    postalCodesResult: types.maybeNull(types.array(PostalCode)),
    fetching: types.string,
    status: types.maybeNull(types.number),
  })
  .actions((self) => ({
    initialPostalCode() {
      self.postalCodesResult = null;
      self.fetching = "done";
    },
    searchOneMap: flow(function* searchPostCode(searchVal: string) {
      self.fetching = "pending";
      self.postalCodesResult = null;
      try {
        // ... yield can be used in async/await style
        const result = yield axios.get(ONEMAP_API, {
          params: {
            searchVal: searchVal,
            getAddrDetails: "Y",
            returnGeom: "Y",
            pageNum: 1,
          },
        });
        console.log("searchPostCode", result);
        self.fetching = "done";
        self.status = result.status;
        self.postalCodesResult = result.data.results;
        console.log(result.data.results);
      } catch (error) {
        // ... including try/catch error handling
        console.log("getHolidays", error);
        self.fetching = "error";
        self.status = error?.response?.status || 500;
        AlertResultApi(
          error?.response?.status || 500,
          error.response?.data?.message
        );
      }
    }),
    searchPostalCode(postal: string) {
      if (self.postalCodesResult) {
        const index = self.postalCodesResult.findIndex((data) => {
          return data.ADDRESS === postal || data.POSTAL === postal;
        });
        console.log(index);

        return index === -1 ? null : { ...self.postalCodesResult[index] };
      }

      return null;
    },
  }))
  .views((self) => ({
    get listPostalCodes() {
      return self.postalCodesResult
        ? self.postalCodesResult.map((data) => data.ADDRESS)
        : [];
    },
  }));

export type RootInstance = Instance<typeof PostalCodes>;
export type PostalCodeType = Instance<typeof PostalCode>;
